import { IonButton } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { ASSESSMENT_STATUSES } from "../../../src/movenet/params";
import AppButton from "../Button/AppButton";

interface Props {
  setExitAssessment: Function;
  setAssesmentError: Function;
}
const NotEnoughSpaceModal: React.FC<Props> = ({
  setExitAssessment,
  setAssesmentError,
}) => {
  let history = useHistory();

  const ExitTest = () => {
    setExitAssessment(false);
    const counter = sessionStorage.getItem("retry-counter");
    if (counter)
      sessionStorage.setItem("retry-counter", (Number(counter) + 1).toString());
    history.push("/patient-page");
  };

  const BackAndCountinue = () => {
    setExitAssessment(false);
    ASSESSMENT_STATUSES.retry = true;
  };

  const retry_task = () => {
    setExitAssessment(false);
    history.push("/angle-adjustment");
  };

  const ExitAssessment = () => {
    ExitTest();
    ASSESSMENT_STATUSES.incomplete_test = true;
    ASSESSMENT_STATUSES.exit_assessment_modal = true;
  };

  return (
    <>
      <div className="exit-assessment-modal">
        <div className="align-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="220"
            height="99"
            viewBox="0 0 220 99"
            fill="none"
          >
            <path
              d="M179.758 94.8456L216.42 58.1718C221.193 53.3966 221.193 45.6416 216.42 40.8663L179.758 4.19251C174.984 -0.582726 167.232 -0.582726 162.458 4.19251C157.684 8.96775 157.684 16.7227 162.458 21.498L178.268 37.3136H41.7411L57.5515 21.498C62.3252 16.7227 62.3252 8.96775 57.5515 4.19251C52.7779 -0.582726 45.0254 -0.582726 40.2517 4.19251L3.58981 40.8663C1.29844 43.1585 0 46.2528 0 49.5C0 52.7471 1.29844 55.8415 3.58981 58.1336L40.2517 94.8074C45.0254 99.5827 52.7779 99.5827 57.5515 94.8074C62.3252 90.0322 62.3252 82.2772 57.5515 77.502L41.7411 61.6864H178.268L162.458 77.502C157.684 82.2772 157.684 90.0322 162.458 94.8074C167.232 99.5827 174.984 99.5827 179.758 94.8074V94.8456Z"
              fill="#890029"
            />
          </svg>

          <p
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              paddingLeft: "30px",
              paddingRight: "30px",
            }}
          >
            Not Enough Space
          </p>
          <p
            style={{
              fontSize: "50px",
              fontWeight: "600",
              lineHeight: "87.16px",
              textAlign: "center",
              paddingLeft: "30px",
              paddingRight: "30px",
            }}
          >
            {" "}
            The chair must be at least 13 feet from the sensor. Please move to a
            larger area.{" "}
          </p>
        </div>
        {/* {sessionStorage.getItem("selectedAssesment") === "55" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "32px",
              padding: "10px 99px 10px 99px",
            }}
          >
            <AppButton
              label="Back"
              variant="secondary"
              onClick={BackAndCountinue}
            />
            <AppButton
              label="Exit"
              variant="primary"
              onClick={ExitAssessment}
            />
          </div>
        ) : ( */}
        <div className="two-col-btn">
          <IonButton
            placeholder={undefined}
            onClick={ExitAssessment}
            className="blue-outline-btn"
          >
            Exit & Discard
          </IonButton>
          <IonButton
            placeholder={undefined}
            onClick={retry_task}
            className="blue-btn"
          >
            Retry
          </IonButton>
        </div>
        {/* )} */}
      </div>
    </>
  );
};
export default NotEnoughSpaceModal;
